<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import defaultFonts from "../../stores/fileTemplateDefaultFonts"
  import QRCode from "qrcode"
  import { push } from "svelte-spa-router"
  import notify from "../../../../../Script/notify"
  import { loadImage, drawChecked } from "../Script/loadImg"
  import WindowDetails from "./windowDetailsModal.svelte"
  import NameAttribute from "../modules/nameAttribute/index.svelte"

  let showWindowDetails = false

  let textCount
  let imageCount

  /**
   * @description to add a newTextLayer
   */
  const addTextLayer = (e) => {
    try {
      if ($fileTemplateState.documentTemplateId == undefined) throw "Choose a document template"

      if ($fileTemplateState.operations.length) {
        showActiveComponent()

        let findTextlayers = $fileTemplateState.operations.filter((operation) => operation.type == "text")
        textCount = findTextlayers.length + 1
      } else {
        textCount = 1
      }

      let textJsonData = {
        active: true,
        hover: false,
        attribute: e.detail.attribute && e.detail.attribute != "Others" ? e.detail.attribute : `text-${textCount}`,
        // attribute: `text-${textCount}`,
        type: "text",
        errorX: false,
        errorY: false,
        value: e.detail.value ? e.detail.value : "Text",
        fontFamily: $fileTemplateState.activeFontFamily,
        // fontSize: $fileTemplateState.activeFontSize || Math.floor($fileTemplateState.canvasHeight * (10 / 100)),
        fontSize: $fileTemplateState.activeFontSize,
        fontStyles: $fileTemplateState.activeFontStyles || [],
        textColor: $fileTemplateState.activeTextColor || "#f2072e",
        x: Math.floor($fileTemplateState.baseImageInfo.width / 2),
        y: Math.floor($fileTemplateState.baseImageInfo.height / 2),
        textAlign: $fileTemplateState.activeTextAlign || "center",
        move: false,
        id: Date.now(),
      }
      $fileTemplateState.activeId = Date.now()
      $fileTemplateState.operations = [...$fileTemplateState.operations, textJsonData]
      showAttributeModal = false
      setTimeout(() => {
        document.getElementById(textJsonData.id).scrollIntoView(true)
      }, 100)
    } catch (error) {
      const info = "PAGE: File template editor\nEVENT: While adding text layer"
      notify.danger(error, info)
    }
  }

  //   /**
  //    * @description function for drawing the checked image
  //    */
  //   const drawChecked = () => {
  //     const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  //  <path d="M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/>
  // </svg>`
  //     // Create an image from the SVG
  //     const svgBlob = new Blob([svg], { type: "image/svg+xml" })
  //     const url = URL.createObjectURL(svgBlob)

  //     return url
  //   }

  /**
   * @description to cretae a new image layer
   */
  const addImageLayer = async () => {
    try {
      if ($fileTemplateState.documentTemplateId == undefined) throw "Choose a document template"

      if ($fileTemplateState.operations.length) {
        showActiveComponent()
        let findImagelayers = $fileTemplateState.operations.filter((operation) => operation.type == "image")
        imageCount = findImagelayers.length + 1
      } else {
        imageCount = 1
      }

      let size = Math.floor($fileTemplateState.baseImageInfo.width / 10)

      let checkedImage = drawChecked(size, size)

      /**
       * @type {import(../../../../../Stores/fileTemplateJsonData).OperationLayersItem}
       */
      let imageJsonData = {
        attribute: `Image-${imageCount}`,
        src: checkedImage,
        image: await loadImage(checkedImage),
        dynamic: false,
        active: true,
        errorX: false,
        errorY: false,
        width: size,
        height: size,
        // to center the x and y position canvasW/2- image/2 same as y
        // image width is 10 % of canvas width
        x: Math.floor(($fileTemplateState.baseImageInfo.width * 0.9) / 2),
        y: Math.floor(($fileTemplateState.baseImageInfo.height * 0.9) / 2),
        type: "image",
        uploadImage: true,
        id: Date.now(),
      }

      $fileTemplateState.activeId = Date.now()
      $fileTemplateState.operations = [...$fileTemplateState.operations, imageJsonData]
      setTimeout(() => {
        document.getElementById(imageJsonData.id).scrollIntoView(true)
      }, 100)
    } catch (error) {
      const info = "PAGE: File template editor\nEVENT: While adding image layer"
      notify.danger(error, info)
    }
  }

  /**
   * @description add a new qrcode layer
   */
  const addQrLayer = async () => {
    try {
      if ($fileTemplateState.documentTemplateId == undefined) throw "Choose a document template"

      if ($fileTemplateState.operations.length) {
        showActiveComponent()
      }

      let qrImage
      try {
        qrImage = await QRCode.toDataURL("https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592", {
          // errorCorrectionLevel: "H",
          // margin: 4,
          color: {
            light: "#ffffff", // Fully transparent background
            dark: "#000000", // Black QR code
          },
        })
      } catch (err) {
        // console.error(err)
      }
      /**
       * @type {import(../../../../../Stores/fileTemplateJsonData).OperationLayersItem}
       */
      let qrJsonData = {
        attribute: "qr",
        maintainAspectRatio: true,
        image: await loadImage(qrImage),
        active: true,
        bgColor: "#ffffff",
        color: "#000000",
        value: "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592",
        width: Math.floor($fileTemplateState.baseImageInfo.width / 10),
        height: Math.floor($fileTemplateState.baseImageInfo.width / 10),
        aspectRatio: 1,
        x: Math.floor($fileTemplateState.baseImageInfo.width / 2 - $fileTemplateState.baseImageInfo.width / 10 / 2),
        y: Math.floor($fileTemplateState.baseImageInfo.height / 2 - $fileTemplateState.baseImageInfo.width / 10 / 2),
        type: "qr",
        id: Date.now(),
      }
      $fileTemplateState.operations = [...$fileTemplateState.operations, qrJsonData]
      setTimeout(() => {
        document.getElementById(qrJsonData.id).scrollIntoView(true)
      }, 100)
    } catch (error) {
      const info = "PAGE: File template editor\nEVENT: While adding QR layer"
      notify.danger(error, info)
    }
  }

  const validateOperations = () => {
    try {
      if (!$fileTemplateState.baseImageInfo.name) throw "File template name can't be empty"

      if ($fileTemplateState.baseImageInfo.name != $fileTemplateState.baseImageInfo.tempName) {
        $fileTemplateState.goBack = true
        return
      }

      if ($fileTemplateState.operations.length == $fileTemplateState.tempOperation.length) {
        for (let i = 0; i < $fileTemplateState.tempOperation.length; i++) {
          for (const [tempKey, tempValue] of Object.entries($fileTemplateState.tempOperation[i])) {
            if (tempKey == "fontStyles" && tempKey != "image") {
              if (JSON.stringify(tempValue) != JSON.stringify($fileTemplateState.operations[i][tempKey])) {
                $fileTemplateState.goBack = true
                // break
                return
              }
            } else {
              if (tempValue != $fileTemplateState.operations[i][tempKey] && tempKey != "image") {
                $fileTemplateState.goBack = true
                // break
                return
              }
            }
          }
        }
        //
      } else if ($fileTemplateState.operations.length != $fileTemplateState.tempOperation.length) {
        $fileTemplateState.goBack = true
        return
      }
      $fileTemplateState.goBack = false
      push("/templates/file")
    } catch (error) {
      const info = "PAGE: File template editor\nEVENT: While validating operations before leaving editor"
      notify.danger(error, info)
    }
  }

  const showActiveComponent = () => {
    $fileTemplateState.operations = $fileTemplateState.operations.map((operation) => {
      operation.active = false
      return operation
    })
  }
  let showAttributeModal = false
</script>

{#if showWindowDetails}
  <div class="z-50">
    <WindowDetails
      on:click={() => {
        showWindowDetails = false
      }}
    />
  </div>
{/if}
{#if showAttributeModal}
  <NameAttribute
    on:click={() => {
      showAttributeModal = false
    }}
    on:setLayer={addTextLayer}
    changeAttribute={true}
    parsedJson={$fileTemplateState.parsedJson}
  />
{/if}

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div type="button" data-tooltip="Back" tooltip-position="right" on:click={validateOperations} class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
  <i class="fa-solid fa-backward" />
</div>
<div class="space-y-5">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    data-tooltip="Text"
    tooltip-position="right"
    on:click={() => {
      showAttributeModal = true
    }}
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-text" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div data-tooltip="Image" tooltip-position="right" on:click={addImageLayer} class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
    <i class="fa-solid fa-image" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div data-tooltip="QR code" tooltip-position="right" on:click={addQrLayer} class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
    <i class="fa-solid fa-qrcode" />
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      $defaultFonts.newFontListModal = true
    }}
    data-tooltip="Add Font"
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-a" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
        opp.active = false
        opp.hover = false
        return opp
      })
      setTimeout(() => {
        $fileTemplateState.download = true
      }, 10)
      $fileTemplateState.notifyFooter = "Downloading...."
    }}
    data-tooltip="Download"
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-download" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    data-tooltip="Reset Pan and Zoom"
    on:click={() => {
      $fileTemplateState.scale = 1
    }}
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-rotate-right" />
  </div>
</div>
<div class="space-y-5">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      showWindowDetails = true
    }}
    data-tooltip="Made with &#128150 by docChain"
    tooltip-position="right"
  >
    <button class="flex h-10 w-10 items-center justify-center rounded-md hover:animate-rotate">
      <svg id="Layer_2" height="25" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 727.6 594.77">
        <defs>
          <style>
            .cls-1 {
              fill: #ff6a00;
            }
          </style>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path class="cls-1" d="m363.8,250.05l-229.9,109.87,229.9,109.88v124.97L55.03,447.21c-73.38-35.07-73.38-139.52,0-174.59L363.8,125.03v125.02Z" />
            <path class="cls-1" d="m363.8,125.02l229.9,109.87-229.9,109.88v124.97l308.76-147.56c73.38-35.07,73.38-139.52,0-174.59L363.8,0v125.02Z" />
          </g>
        </g>
      </svg>
    </button>
  </div>
</div>
